import React , { useEffect , useCallback , useState , useRef } from 'react';
import { useParams } from 'react-router-dom';
import Select from 'react-select';

import { useGlobalContext } from '../../context/GlobalContext';

import MediaCard from './MediaCard';
import Modale from '../../partials/Modale';
import AddMedia from './AddMedia';
import RemoveModale from '../../partials/RemoveModale/RemoveModale'; 
import { companiesColors } from '../../../utils/utils';

import { getCompanyAction } from '../../../actions/companiesActions';
import { getMediasPageAction, mediasTabToApiType, invalidateMediasCache } from '../../../actions/mediasActions';

import './medias.scss';
import EditMedia from './EditMedia';

const PAGE_LIMIT = 24;

export default function MediasPage(props) {
  const customStyles = {
    multiValue: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? companiesColors[theme] : companiesColors[theme] 
    }),
    multiValueLabel: (provided, state) => ({
      ...provided,
      color: 'white'
    }),
    container: (provided, state) => ({
      ...provided,
      width: '100%',
      marginTop:7,
      marginBottom:20,
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      padding: "0px 8px",
      fontSize: 14
    }),
    control: (provided, state) => ({
      ...provided,
      boxShadow: "none",
      minHeight: 44,
      borderRadius: 10,
      border: state.isFocused || state.isSelected ? "1px solid " + companiesColors[theme] : "1px solid #E0E3EF"
    })
  }

  const [ context, dispatch ] = useGlobalContext();
  const param = useParams();
  const containerRef = useRef();

  const { setDisplayNavBar , setActivePage , theme , setDisplaySiteNav, lang } = props;
  const sortOptions = [
    { value: 'images' , label: 'Les images' },
    { value: 'vidéos' , label: 'Les vidéos' },
    { value: 'fichiers' , label: 'Les fichiers' },
    { value:'miniatures' ,  label: 'Les miniatures' },
  ]

  const [ mediaList , setMediaList ] = useState([]);
  const [ search , setSearch ] = useState('');
  const [ debouncedSearch , setDebouncedSearch ] = useState('');
  const [ selectedList , setSelectedList ] = useState(sortOptions[0]);
  const [ addMediaIsOpen , setAddMediaIsOpen ] = useState(false);
  const [ editMedia , setEditMedia ] = useState();
  const [ removeAction , setRemoveAction ] = useState();
  const [ page , setPage ] = useState(1);
  const [ total , setTotal ] = useState(0);
  const [ loading , setLoading ] = useState(false);
  const [ refreshKey , setRefreshKey ] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedSearch(search), 300);
    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    setPage(1);
  }, [debouncedSearch, selectedList]);

  const fetchMedias = useCallback(async () => {
    if (!param.companyId) {
      return;
    }

    setLoading(true);
    try {
      const result = await getMediasPageAction(dispatch, {
        companyId: param.companyId,
        type: mediasTabToApiType(selectedList.value),
        search: debouncedSearch,
        page,
        limit: PAGE_LIMIT
      });
      setMediaList(result.files);
      setTotal(result.total);
    } finally {
      setLoading(false);
    }
  }, [dispatch, param.companyId, selectedList.value, debouncedSearch, page, refreshKey]);

  useEffect(() => {
    fetchMedias();
  }, [fetchMedias]);

  const getDatas = useCallback(() => {
    getCompanyAction(dispatch , param.companyId );
  },[dispatch , param.companyId ]);

  useEffect(() => {
    setDisplayNavBar(true);
    setDisplaySiteNav(false);
    setActivePage("medias")
    getDatas();
    // eslint-disable-next-line
  }, []);

  function handleMediaRemoved() {
    invalidateMediasCache(param.companyId);
    setRefreshKey((k) => k + 1);
  }

  function handleMediaSaved() {
    invalidateMediasCache(param.companyId);
    setRefreshKey((k) => k + 1);
  }

  const totalPages = Math.max(1, Math.ceil(total / PAGE_LIMIT));

  const tabTitles = {
    images: 'Les images',
    'vidéos': 'Les vidéos',
    fichiers: 'Les fichiers',
    miniatures: 'Les miniatures'
  };

  function renderMediaList() {
    if (loading && !mediaList.length) {
      return <p>Chargement…</p>;
    }

    return (
      <div className="category">
        <div className="title">
          <h2>{tabTitles[selectedList.value]}</h2>
        </div>
        <div className="media-list">
          {!mediaList.length ?
            <p>Aucun média trouvé.</p>
            :
            mediaList.map((media) => (
              <MediaCard
                key={media._id}
                theme={theme}
                media={media}
                setEditMedia={setEditMedia}
                setRemoveAction={setRemoveAction}
                dispatch={dispatch}
                companyId={param.companyId}
                onDeleted={handleMediaRemoved}
              />
            ))
          }
        </div>
      </div>
    );
  }

  return (
    <>
      <div className={`page-container ${theme}`}>
      <div className="page-content">

        <div className="title-row space-between">

          <div className="title">
            <h1>Médiathèque</h1>
            <div className="bar primary"></div>
          </div>

          <input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Recherche"
            />
          
          <div className="select">
            <Select
              styles={customStyles}
              value={selectedList}
              isSearchable={false}
              options={sortOptions}
              placeholder={''}
              onChange={(val) => setSelectedList(val)}
            />
          </div>
  

          <button
            onClick={() => setAddMediaIsOpen(true)}
            className="btn primary">
            Ajouter un fichier
          </button>
        </div>

        <div ref={containerRef} className="media-list">
          {renderMediaList()}
        </div>

        {totalPages > 1 &&
          <div className="btn-container" style={{ justifyContent: 'center', gap: 12, marginTop: 20 }}>
            <button
              type="button"
              className="btn grey"
              disabled={page <= 1 || loading}
              onClick={() => setPage((p) => Math.max(1, p - 1))}
            >
              Précédent
            </button>
            <span>{page} / {totalPages} ({total} médias)</span>
            <button
              type="button"
              className="btn grey"
              disabled={page >= totalPages || loading}
              onClick={() => setPage((p) => p + 1)}
            >
              Suivant
            </button>
          </div>
        }

        </div>
      </div>
      <RemoveModale removeAction={removeAction} setRemoveAction={setRemoveAction} theme={theme}/> 
      <Modale
        modaleIsOpen={addMediaIsOpen}
        modaleToggle={setAddMediaIsOpen}
        className={"add-media-modale"}
        >
        {addMediaIsOpen && <AddMedia
          theme={theme}
          lang={lang}
          type=""
          setAddMediaIsOpen={setAddMediaIsOpen}
          companyId={param.companyId}
          onSaved={handleMediaSaved}
          />
        }
      </Modale>
      <Modale
        modaleIsOpen={editMedia}
        modaleToggle={() => setEditMedia()}
        className={"add-media-modale"}
        >
        {editMedia && <EditMedia
          theme={theme}
          lang={lang}
          media={editMedia}
          setEditMedia={setEditMedia}
          companyId={param.companyId}
          type=""
          onSaved={handleMediaSaved}
          />
        }
      </Modale>
    </>
  )
}
